import { render } from "./outStock.vue?vue&type=template&id=d95c3994&scoped=true"
import script from "./outStock.vue?vue&type=script&lang=js"
export * from "./outStock.vue?vue&type=script&lang=js"

import "./outStock.vue?vue&type=style&index=0&id=d95c3994&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d95c3994"

export default script